/**
 * Reading of each point where the DGI protocol annex SECEF BF ST 1.0
 * contradicts itself. Every codec function takes an optional dialect and
 * defaults to `DEFAULT_SECEF_DIALECT`; the package README lists each point,
 * the default and the alternative.
 *
 * @module @efacture/mcf-protocol/secef-dialect
 */
/** Largest DATA a one-byte LEN allows in a response: FFh - 20h - 11. */
export const SECEF_LEN_BOUND_RESPONSE_DATA_LENGTH = 0xff - 0x20 - 11;
export const DEFAULT_SECEF_DIALECT = Object.freeze({
    responseBccSpan: "LEN-AMB",
    newlineEscapes: "hex-code",
    field38hOrder: "example",
    dataControlBytes: Object.freeze([0x09, 0x0a]),
    maxCommandDataLength: 200,
    maxResponseDataLength: SECEF_LEN_BOUND_RESPONSE_DATA_LENGTH,
    importedServiceCode: "IMPSER",
    taxRegimeLid: "REGIMP",
    itemTypeTaxComma: true,
    trimFieldSpaces: true,
    amountRounding: "half-up",
});
/** Returns the default dialect with the given points overridden. */
export function secefDialect(overrides = {}) {
    return Object.freeze({ ...DEFAULT_SECEF_DIALECT, ...overrides });
}
